import BeerSectionItem from "./BeerSectionItem"
import SectionItem from "./SectionItem";
import { isBeer, isBurger, isWine } from "../common/utils";
import WineSectionItem from "./WineSectionItem";
import BurgerSectionItem from "./BurgerSectionItem";

const Section = ({ isOpen, section }) =>{
    const sortedItems = section.items.slice().sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    return (
      <>
        <div className={"menu-items " + (isOpen.includes(section.id) ? "_collapsed" : "")}>
          <div className={"section-header-subtitle " + (isOpen.includes(section.id) ? "_collapsed" : "")}>
            {section.subtitle}
          </div>
          {isBeer(section.sectionName) ? (
              section.items.map(item => (
                <BeerSectionItem isOpen={isOpen} section={section} item={item} />
              ))
          ) : (
            isWine(section.sectionName) ? (
              section.items.map(item => (
                  <WineSectionItem isOpen={isOpen} section={section} winery={item} />
                ))
            ) : isBurger(section.sectionName) ? (
              section.items.map(item => (
                <BurgerSectionItem isOpen={isOpen} section={section} burgers={item} />
              ))
            ) : (
              sortedItems.map(item => (
                  <SectionItem isOpen={isOpen} section={section} item={item} />
                ))
            )
          )}
        </div>
      </>
    );
}
export default Section;